module.exports = [{"key":"1","name":"明细插件","icon":"","editTime":"2017-11-11","canEdit":false},{"key":"2","name":"字段联动","icon":"","editTime":"2017-11-11","canEdit":false}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/datas_develop.json
// module id = 533
// module chunks = 0